import CategoryPage from "@/pages/category/components/CategoryPage";

export default function Movies() {
  return (
    <CategoryPage
      category="movie"
      categoryLabel="电影"
      path="/movies"
      h1="电影分类"
      description="可可影视电影频道收录院线热映、口碑佳作与经典回顾，支持按类型、地区、年份与评分区间组合筛选，帮助你快速找到值得一看的电影。"
      keywords="电影推荐,最新电影,电影分类,电影评分,可可影视电影"
    />
  );
}